// extracted by mini-css-extract-plugin
module.exports = {"figure":"SmallFigure--figure--1kjEo","background":"SmallFigure--background--P7-zp"};